import React from "react";
import styled, { css } from "styled-components";

const Input = styled.input.attrs({
  type: "text",
  placeholder: (props) => (props.required && !props.placeholder ? "Required..." : ""),
})`
  min-width: 100px;
  width: ${(props) => (props.fullWidth ? "90%" : "100px")};
  height: ${(props) => (props.fullWidth ? "inherit" : "26px;")};
  padding-left: 5px;
  padding-top: 2px;
  padding-bottom: 2px;
  ${(props) =>
    props.fullWidth &&
    css`
      padding: 10px;
    `};
  border: ${(props) => (props.fullWidth ? "1px solid #DDD" : "0px;")};
  background-color: ${(props) => (props.required ? !props.value && "#FFBBBB" : "inherit")};
  ${(props) =>
    props.highlighted &&
    css`
      background-color: #ecffa4;
      color: #ecffa4;
    `};
  & :focus {
    ${(props) =>
      props.fullWidth &&
      css`
        border: 10px solid #aaaaaa !important;
      `};
  }
`;

export default Input;
